import React, { useContext, useEffect, useState } from 'react';
import { IconContext } from 'react-icons';
import { VscSearch } from 'react-icons/vsc';
import Sort from './Components/Sort';
import Filter from './Components/Filter';
import Pagination from './Components/Pagination';
import { ConsignmentRootDataContext } from 'Pages/UserDashboard/Consignment/Contexts/ConsignmentRootData';

interface ITabToolbarProps {
  paginationData: any;
}

const TabToolbar: React.FC<ITabToolbarProps> = (props) => {
  const { paginationData } = props;
  const consignmentContext = useContext(ConsignmentRootDataContext);
  const form = consignmentContext.value.formTabToolbar;
  const [text, setText] = useState('');

  const onChangeSearchText = (e) => {
    const value = e.target.value;
    const isEmptyAndHaveValueBefore = !value && text;
    if (isEmptyAndHaveValueBefore) {
      form?.setFieldValue('keyword', value);
    }
    setText(value);
  };

  const onKeyDown = (event) => {
    if (event.key === 'Enter') {
      form?.setFieldValue('keyword', text);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      consignmentContext.value.setIsFirstRenderTabToolbar(false);
      consignmentContext.value.dispatch();
    }, 1000);
  }, []);

  return (
    <div className={'table-header-container'}>
      <div className={'search-container'}>
        <IconContext.Provider value={{ color: '#242424', size: '17px' }}>
          <div>
            <VscSearch />
          </div>
        </IconContext.Provider>
        <input
          type={'text'}
          placeholder={`Search your listings here`}
          className={'input-text'}
          value={text}
          onChange={onChangeSearchText}
          onKeyDown={onKeyDown}
        />
      </div>
      <Sort />
      <Filter />
      <Pagination paginationData={paginationData} />
    </div>
  );
};

export default TabToolbar;
